'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addLocation = addLocation;

var _actionTypes = require('../actionTypes');

var _actionTypes2 = _interopRequireDefault(_actionTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // eslint-disable-next-line import/prefer-default-export


function addLocation(location) {
  return {
    type: _actionTypes2.default.ADD_LOCATION,
    location: location
  };
}